import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setActiveTab } from "../../store/tabSlice";
import { useTheme } from "../../ThemeContext";
import { RootState } from "../../store";
import classNames from "classnames";
import styles from "./NavigationMenu.module.css";

// آیکون‌های تم‌پذیر شده
import { ReactComponent as HomeActiveIcon } from "../../assets/icons/homeactive.svg";
import { ReactComponent as HomeInactiveIcon } from "../../assets/icons/home.svg";
import { ReactComponent as CalendarActiveIcon } from "../../assets/icons/TimesActive.svg";
import { ReactComponent as CalendarInactiveIcon } from "../../assets/icons/Times.svg";
import { ReactComponent as ProfileActiveIcon } from "../../assets/icons/profileActive.svg";
import { ReactComponent as ProfileInactiveIcon } from "../../assets/icons/Profile.svg";

interface NavigationMenuProps {
  className?: string;
}

interface TabItemProps {
  to: string;
  activeIcon: React.ElementType;
  inactiveIcon: React.ElementType;
  label: string;
  tabKey: "home" | "appointments" | "profile";
  activeTab: "home" | "appointments" | "profile";
  onClick: (tab: "home" | "appointments" | "profile") => void;
}

const TabItem: React.FC<TabItemProps> = React.memo(
  ({
    to,
    activeIcon: ActiveIcon,
    inactiveIcon: InactiveIcon,
    label,
    tabKey,
    activeTab,
    onClick,
  }) => {
    const isActive = activeTab === tabKey;

    return (
      <Link to={to} className={styles.tabItem} onClick={() => onClick(tabKey)}>
        {isActive ? (
          <ActiveIcon
            className={classNames(styles.tabIcon, styles.tabIconActive)}
          />
        ) : (
          <InactiveIcon className={styles.tabIcon} />
        )}
        <p
          className={classNames(styles.tabText, {
            [styles.tabTextActive]: isActive,
          })}
        >
          {label}
        </p>
      </Link>
    );
  }
);

const NavigationMenu: React.FC<NavigationMenuProps> = React.memo(
  ({ className }) => {
    const dispatch = useDispatch();
    const { isDarkMode } = useTheme();
    const activeTab = useSelector((state: RootState) => state.tab.activeTab);

    const handleTabClick = (tab: "home" | "appointments" | "profile") => {
      if (activeTab !== tab) dispatch(setActiveTab(tab));
    };

    const tabs = useMemo(
      () => [
        {
          to: "/profile",
          activeIcon: ProfileActiveIcon,
          inactiveIcon: ProfileInactiveIcon,
          label: "پروفایل",
          key: "profile",
        },
        {
          to: "/times",
          activeIcon: CalendarActiveIcon,
          inactiveIcon: CalendarInactiveIcon,
          label: "نوبت‌ها",
          key: "appointments",
        },
        {
          to: "/main",
          activeIcon: HomeActiveIcon,
          inactiveIcon: HomeInactiveIcon,
          label: "خانه",
          key: "home",
        },
      ],
      []
    );

    return (
      <>
        <div
          className={classNames(styles.menuWrapper, className, {
            [styles.dark]: isDarkMode,
          })}
        >
          <div className={styles.menuInner}>
            {tabs.map(({ to, activeIcon, inactiveIcon, label, key }) => (
              <TabItem
                key={key}
                to={to}
                activeIcon={activeIcon}
                inactiveIcon={inactiveIcon}
                label={label}
                tabKey={key as "home" | "appointments" | "profile"}
                activeTab={activeTab}
                onClick={handleTabClick}
              />
            ))}
          </div>
          <div className={styles.blurOverlay} />
        </div>

        {/* 👇 این خط مهم */}
        <div className={styles.safeAreaBottom} />
      </>
    );
  }
);

export default NavigationMenu;
